import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { CanvasComponent } from "./components/canvas/canvas.component";
import { CanvasElementComponent } from "./components/canvas-element/canvas-element.component";
import { ToolbarComponent } from "./components/toolbar/toolbar.component";
import { ImageGalleryComponent } from "./components/image-gallery/image-gallery.component";
import { SlideNavigatorComponent } from "./components/slide-navigator/slide-navigator.component";

import { CanvasService } from "./services/canvas.service";
import { ElementFactoryService } from "./services/element-factory.service";
import { CanvasDesignerComponent } from "./components/canvas-designer/canvas-designer.component";

@NgModule({
  declarations: [
    CanvasDesignerComponent,
    CanvasComponent,
    CanvasElementComponent,
    ToolbarComponent,
    ImageGalleryComponent,
    SlideNavigatorComponent,
  ],
  imports: [CommonModule, FormsModule],
  exports: [
    CanvasDesignerComponent,
    CanvasComponent,
    CanvasElementComponent,
    ToolbarComponent,
    ImageGalleryComponent,
    SlideNavigatorComponent,
  ],
  providers: [],
})
export class CanvasLibraryModule {}
